import styled from 'styled-components';

export const CardWrapper = styled.div`
  margin-top: 4rem;
  min-height: 20rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  //padding: 0.5rem;
  background-color: ${(props) =>
    !props.dark ? 'white' : props.theme.colors.dark};
  box-shadow: ${(props) =>
    !props.dark
      ? props.theme.shadows.shadow1
      : 'rgba(11, 33, 74, 0.09) 0px 3px 6px 0px, rgba(11, 33, 74, 0.03) 0px -2px 2px 0px'};
  border-radius: 0.5rem;
  overflow: hidden;

  .image-container {
    flex: 2;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .content-container {
    flex: 1;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    padding: 0.5rem 1.5rem;
    .title {
      font-weight: 700;
      font-size: 25px;
      padding: 0;
      margin: 0;
      margin-bottom: 1.5rem;
      color: ${(props) => (props.dark ? 'white' : props.theme.colors.dark)};
    }
    .excerpt {
      margin-bottom: 1rem;
      color: ${(props) =>
        props.dark ? props.theme.colors.dark3 : props.theme.colors.dark};

      font-family: ${(props) => props.theme.fonts.karla};
    }
    .author-info {
      font-weight: 500;
      font-size: 17px;
      color: ${(props) => (props.dark ? 'white' : props.theme.colors.dark)};
    }
    .date {
      margin-bottom: 0.5rem;
      span {
        color: rgb(139, 139, 139);
      }
    }
    .tags {
      display: flex;
      margin-bottom: 0.5rem;
      .tag-element {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.2em 0.5em;
        text-decoration: none;
        margin: 0 0.5em;
        min-width: 4rem;
        background-color: blueviolet;
        border-radius: 0.25rem;
        .tag-link {
          text-decoration: none;
          display: flex;
          align-items: center;
          font-size: 13px;
        }
        transition: filter 300ms ease;
      }
      .tag-element:hover {
        cursor: pointer;
        filter: brightness(90%);
        transition: filter 300ms ease;
      }
    }
    .button-container {
      margin: 0.3rem 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;
    .image-container {
      min-height: 15rem;
    }
    .content-container {
      padding: 0.5rem 1.5rem 1rem 1.5rem;
    }
  }
`;
